var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"timeSource"},[_c('span',[_vm._v("上传时间:"+_vm._s(_vm.data.time))]),_c('span',[_vm._v("|")]),_c('span',[_vm._v("数据来源:"+_vm._s(_vm.data.source))])])}
var staticRenderFns = []

export { render, staticRenderFns }